var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { attrs: { title: "Alerts" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.loaded
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "column" },
                [
                  _c("MetricGraph", {
                    attrs: {
                      metrics: _vm.metrics,
                      name: "Total Alerts",
                      date: _vm.date,
                      period: _vm.period,
                      lastUpdate: _vm.lastUpdate,
                      metricProperties: _vm.metricProperties,
                      metricProperty: _vm.metricProperty
                    },
                    on: { updateMetric: _vm.updateMetric }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "column" }, [
                _c(
                  "div",
                  { staticClass: "alerts", attrs: { id: "alerts-priority" } },
                  [_c("AlertsPriorityList", { attrs: { alerts: _vm.alerts } })],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass:
            "inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200",
          attrs: { to: "/" + _vm.id + "/alerts" }
        },
        [
          _vm._v("\n  View Detailed Alerts Report\n  "),
          _c(
            "svg",
            {
              staticClass: "ml-2 h-4 w-4",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                "stroke-width": "2"
              }
            },
            [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76f10c5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76f10c5d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/InfoCards/AlertsCard.vue
// module id = null
// module chunks = 